// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"aiembed","594":"about"}[chunkId] + "." + {"272":"28f818e5","594":"22c1ab5c"}[chunkId] + ".css";
};